import { Box, Grid } from '@mui/material';
import { useCommonStyles } from 'components/TeamOverview/BillingSection/styles';
import { DATE_REQUEST_FORMAT, formatDate } from 'utilities/dates_and_times';
import React, { memo } from 'react';
import { BLOCKS_V2_URL } from 'constants/urls';

export const BlockManagerRow = memo(
  ({
    orderId,
    blocksCount,
    statusLabel,
    user,
    fulfilledDate,
    nextBillingDate,
  }) => {
    const { classes } = useCommonStyles();

    return (
      <Grid container className={classes.row} paddingLeft={8}>
        <Grid xs={3} className={`${classes.rowWithLeftPadding}`}>
          <Box
            className={`${classes.link}`}
            onClick={() =>
              window.open(`${BLOCKS_V2_URL}#order=${orderId}`, '_blank')
            }
          >
            {orderId}
          </Box>
        </Grid>
        <Grid xs={1}>{blocksCount}</Grid>
        <Grid xs={2}>
          <Box width="7rem">{statusLabel}</Box>
        </Grid>
        <Grid xs={2}>{user}</Grid>
        <Grid xs={2}>{formatDate(fulfilledDate, DATE_REQUEST_FORMAT)}</Grid>
        <Grid xs={2} className={classes.boldText}>
          {formatDate(nextBillingDate, DATE_REQUEST_FORMAT)}
        </Grid>
      </Grid>
    );
  },
);

BlockManagerRow.displayName = 'BlockManagerRow';
